module.exports = __webpack_public_path__ + "img/featured-vehicles-v2-infiniti.b7598ad9.png";